import classNames from "classnames";
import pluralize from "pluralize";
import {Fragment} from "react";
import {FiCheck, FiLoader, FiStopCircle} from "react-icons/fi";

import {Accordion} from "@/components/accordion/Accordion.tsx";
import {Divider} from "@/components/divider/Divider.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {ANALYZER_TOOL_GROUP_FALLBACK_TITLE} from "@/pages/analyzer/Analyzer.constants.ts";
import {AnalyzerPhase, AnalyzerToolGroupProps} from "@/pages/analyzer/Analyzer.types.ts";
import {AnalyzerToolGroupAction} from "@/pages/analyzer/components/chat/AnalyzerToolGroupAction.tsx";
import {useAnalyzerContext} from "@/pages/analyzer/hooks/AnalyzerContext.tsx";

import styles from "./AnalyzerToolGroup.module.scss";

export const AnalyzerToolGroup = ({item, isLast, className}: AnalyzerToolGroupProps) => {
  const {activeToolGroup, setActiveToolGroup, phase} = useAnalyzerContext();
  const {calls, isComplete, title, titleDone} = item;
  const inProgress = !isComplete && !!isLast && phase === AnalyzerPhase.STREAMING;
  const heading = isComplete
    ? titleDone || title || ANALYZER_TOOL_GROUP_FALLBACK_TITLE.complete
    : title || ANALYZER_TOOL_GROUP_FALLBACK_TITLE.active;
  const groupKey = calls[0].call.call_id;
  let headerIcon = {icon: FiStopCircle, className: "pulse-color-gray-600"};
  if (isComplete) {
    headerIcon = {icon: FiCheck, className: "pulse-color-green-600"};
  } else if (inProgress) {
    headerIcon = {icon: FiLoader, className: "pulseSpin"};
  }

  return (
    <Accordion
      className={classNames(styles.group, className)}
      activeKey={activeToolGroup === groupKey ? "actions" : null}
      onSelect={(eventKey) => setActiveToolGroup(eventKey ? groupKey : null)}
    >
      <Accordion.Item eventKey="actions">
        <Accordion.Header className={styles.header}>
          <Icon icon={headerIcon.icon} className={headerIcon.className} size="normal" removeDivDimensions />
          <span className={styles.heading}>{heading}</span>
          <span className={styles.count}>
            {calls.length} {pluralize("action", calls.length)}
          </span>
        </Accordion.Header>
        <Accordion.Body className={styles.actions}>
          <Accordion>
            {calls.map((toolCall, index) => (
              <Fragment key={toolCall.call.call_id}>
                {index > 0 && <Divider color="subMenu" className={styles.divider} />}
                <AnalyzerToolGroupAction toolCall={toolCall} inProgress={inProgress} />
              </Fragment>
            ))}
          </Accordion>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};
